export default __webpack_public_path__ + "static/BeforeYouStart-bdca6dc786270642cb679269ec060485.png";